import { useState, useCallback } from 'react';

import { useHelpPanel } from './useHelpPanel';

type FetchFunction<T, P extends any[]> = (
  hc_base_url: string,
  locale: string,
  ...args: P
) => Promise<T>;

export const useVimeoHC = <T, P extends any[]>(fetchFunction: FetchFunction<T, P>) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const { locale, hc_base_url } = useHelpPanel();

  const execute = useCallback(
    async (...args: P) => {
      setLoading(true);
      setError(null);
      try {
        const result = await fetchFunction(hc_base_url, locale, ...args);
        setData(result);
        return result;
      } catch (e) {
        if ((e as Error).name === 'AbortError') {
          return null;
        }
        setError(e as Error);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [fetchFunction, locale, hc_base_url],
  );

  return { data, loading, error, execute };
};
